const CONVERSION_TYPE_OPTIONS = [
   {
      value: 'regular',
      label: 'Regular',
   },
   {
      value: 'clickcast',
      label: 'Clickcast',
   },
];

export default CONVERSION_TYPE_OPTIONS;
